import { React, useState } from "react";
import {
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  Container,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  Divider,
  Box,
  MenuItem,
  Fade,
  Alert,
  AlertTitle,
  CircularProgress,
  Autocomplete
} from "@mui/material/";


// Component
import GetAllParts from "../components/GetAllParts";

//Data
import CARS from "../public/data/CarDataKeyedByYear.json";

// Icons
import AddBoxIcon from "@mui/icons-material/AddBox";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";

// Functions
import postSubmission from "../functions/post-submission";
import sleep from "../functions/sleep.js";

export default function (props) {
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [trim, setTrim] = useState("");
  const [year, setYear] = useState("");
  const [exhaustType, setExhaustType] = useState("");
  const [driveTrain, setDriveTrain] = useState("");
  const [videoName, setVideoName] = useState("");
  const [videoLink, setVideoLink] = useState("");
  const [videoDescription, setVideoDescription] = useState("");
  const [existingPartInfo, setExistingPartInfo] = useState([
    {
      partName: "",
    },
  ]);
  const [partInfo, setPartInfo] = useState([]);
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [submitterEmail, setSubmitterEmail] = useState("");
  const [videoPermissionTrue, setVideoPermissionTrue] = useState(false);
  const [formSubmitMessageOpen, setFormSubmitMessageOpen] = useState([false, ""]);
  const [partsNameList, setPartsNameList] = useState([]);
  const [partsCount, setPartsCount] = useState(0);

  const alertBox = {
    height: "50px",
    width: "100%",
    top: "70px !important",
    left: "0px",
    zIndex: 2,
    marginBottom: "10px",
    position: "fixed",
  };

  const retrievePartsNamesList = (nameList) => {
    // 👇️ take parameter passed from Child component
    setPartsNameList(nameList);
    setPartsCount(nameList.length)
  };

  const submitCarForm = () => {
    //Special handling to use localhost SAM API if running locally via npm start(make run)
    const apiUrl =
      process.env.NODE_ENV !== "development"
        ? "https://api." + process.env.NEXT_PUBLIC_DOMAIN + "/submissions"
        : process.env.NEXT_PUBLIC_USER_API_URL_LOCAL_SAM + "/submissions";

    // -----------------------
    // ----- Validations -----
    // -----------------------

    let invalidFields = [];
    const emailRegex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const linkRegex = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;

    // Ensure needed values are not empty
    if (typeof make === "undefined" || make === "") {
      invalidFields.push("Make ");
    }
    if (typeof model === "undefined" || model === "") {
      invalidFields.push("Model ");
    }
    if (typeof trim === "undefined" || trim === "") {
      invalidFields.push("Trim ");
    }
    if (typeof year === "undefined" || year === "") {
      invalidFields.push("Year ");
    }
    if (typeof exhaustType === "undefined" || exhaustType === "") {
      invalidFields.push("Exhaust Type ");
    }

    //Ensure email is valid
    if (typeof submitterEmail === "undefined" || submitterEmail === "") {
      invalidFields.push("Email ");
    } else if (!submitterEmail.match(emailRegex)) {
      invalidFields.push("Email ");
    }

    //Ensure videoName is valid
    if (typeof videoName === "undefined" || videoName === "") {
      invalidFields.push("Video Name ");
    }

    //Ensure videoLink is valid
    if (typeof videoLink === "undefined" || videoLink === "") {
      invalidFields.push("Video Link ");
    } else if (!videoLink.match(linkRegex)) {
      invalidFields.push("Video Link ");
    }



    //ToDo: Ensure at least on part provided
    if (! (existingPartInfo.length > 0 || partInfo.length)) {
      invalidFields.push("Must provide at least 1 part ");
    }

    // Check if an existing part was provided
    if (existingPartInfo.length > 0){
      partInfo.map((part) => {
        if (typeof part === "undefined" || part === "") {
          invalidFields.push("Part Name ");
        }
      });
    }

    // Check if a new part was created
    if (partInfo.length > 0) {
      // Ensure new part fields are valid
      partInfo.map((part) => {
        //Ensure product link is valid
        if (typeof part['productLink'] === "undefined" || part['productLink'] === "") {
          invalidFields.push("Product Link ");
        } else if (!part['productLink'].match(linkRegex)) {
          invalidFields.push("Product Link ");
        }
  
        //Ensure Manufacturer Name is valid
        if (typeof part['manufacturerName'] === "undefined" || part['manufacturerName'] === "") {
          invalidFields.push("Manufacturer Name ");
        }
  
        //Ensure Part Name is valid
        if (typeof part['partName'] === "undefined" || part['partName'] === "") {
          invalidFields.push("Part Name ");
        }
      })

    }

    // Combine existing and new parts data in prep to make API call
    const totalParts = {
      "existingParts": existingPartInfo,
      "newParts": partInfo
    }

    // -----------------------

    // If no invalid fields, call the postSubmission API
    if (invalidFields.length === 0) {
      postSubmission(
        apiUrl,
        make,
        model,
        trim,
        year,
        submitterEmail,
        exhaustType,
        driveTrain,
        videoName,
        videoLink,
        videoDescription,
        totalParts,
        additionalInfo,
        videoPermissionTrue
      ).then((data) => {
        if (data["message"] === "Successfully submitted form") {
          setFormSubmitMessageOpen([true, "success"]);
          setMake("");
          setModel("");
          setTrim("");
          setYear("");
          setExhaustType("");
          setDriveTrain("");
          setVideoName("");
          setVideoLink("");
          setVideoDescription("");
          setPartInfo([
            {
              productLink: "",
              manufacturerName: "",
              partName: "",
            },
          ]);
          setAdditionalInfo("");
          setVideoPermissionTrue(false);
          setSubmitterEmail("");
        }
      });
    } else {
      setFormSubmitMessageOpen([true, invalidFields]);
    }
  };

  function addAnotherPart() {
    // Add another empty part to part data array
    const newPartInfo = partInfo.slice();
    newPartInfo.push({
      productLink: "",
      manufacturerName: "",
      partName: "",
    });
    setPartInfo(newPartInfo);
  }

  function removeAPart() {
    const newPartInfo = partInfo.slice();
    newPartInfo.pop();
    setPartInfo(newPartInfo);
  }

  // ---------- Handle existing part name collection --------------
  function addAnotherExistingPart() {

    // Add another empty part to part data array
    const additionalExistingPartInfo = existingPartInfo.slice();
    additionalExistingPartInfo.push({
      partName: "",
    });
    setExistingPartInfo(additionalExistingPartInfo);
  }

  function removeAnExistingPart() {
    const existingPartInfo = partInfo.slice();
    existingPartInfo.pop();
    setExistingPartInfo(existingPartInfo);
  }

  function singleExistingPartCollection(numberPart) {
    const handlePartNameChange = (partName) => {
      const selectedExistingPartInfo = [...existingPartInfo];
      selectedExistingPartInfo[numberPart]["partName"] = partName;
      setExistingPartInfo(selectedExistingPartInfo);
    };

    return (
      <Grid key={`existingPart${numberPart}`} item sx={{ marginBottom: "25px" }} xs={12}>
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={partsNameList}
          renderInput={(params) => <TextField {...params} label="Part" />}
          value={existingPartInfo[numberPart]['partName']}
          onChange={(event, newValue) => {
            handlePartNameChange(newValue['id'])
          }}
          inputValue={existingPartInfo[numberPart]['partName']}
        />
      </Grid>
    )
  }

  function ExistingPartsCollectionForm() {
    const fields = [];
    for (let i = 1; i <= existingPartInfo.length; i++) {
      fields.push(singleExistingPartCollection(i - 1));
    }

    return (
      <>
        {fields}
        <Grid sx={{ mt: 2 }} item xs={12}>
          <Button variant="contained" align="center" color="success" onClick={addAnotherExistingPart}>
            <AddBoxIcon sx={{ mr: 1 }} />
            <Typography> add part</Typography>
          </Button>

          <Button variant="contained" align="center" color="error" sx={{ ml: 1 }} onClick={removeAnExistingPart}>
            <IndeterminateCheckBoxIcon sx={{ mr: 1 }} />
            <Typography> remove part</Typography>
          </Button>
        </Grid>
      </>);
  }

  function singleNewPartCollection(numberPart) {
    const handleProductLinkChange = (event) => {
      const newPartInfo = [...partInfo];
      newPartInfo[numberPart]["productLink"] = event.target.value;
      setPartInfo(newPartInfo);
    };

    const handleManufacturerNameChange = (event) => {
      const newPartInfo = [...partInfo];
      newPartInfo[numberPart]["manufacturerName"] = event.target.value;
      setPartInfo(newPartInfo);
    };

    const handlePartNameChange = (event) => {
      const newPartInfo = [...partInfo];
      newPartInfo[numberPart]["partName"] = event.target.value;
      setPartInfo(newPartInfo);
    };

    return (
      <>
        <Grid item xs={12} sm={12}>
          <Typography sx={{ mt: 2 }}>Part {numberPart + 1}</Typography>
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            id="productLink"
            type="productLink"
            placeholder="Enter the product link"
            label="Product Link"
            variant="outlined"
            fullWidth
            required
            value={partInfo[numberPart]["productLink"]}
            onChange={handleProductLinkChange}
          />
        </Grid>

        <Grid xs={12} sm={12} item sx={{ mt: 2 }}>
          <TextField
            id="manufacturerName"
            placeholder="Enter the manufacturer name"
            label="Manufacturer Name"
            variant="outlined"
            fullWidth
            required
            value={partInfo[numberPart]["manufacturerName"]}
            onChange={handleManufacturerNameChange}
          />
        </Grid>

        <Grid xs={12} sm={12} item sx={{ mt: 2 }}>
          <TextField
            id="partName"
            placeholder="Enter the part's name"
            label="Part Name"
            variant="outlined"
            fullWidth
            required
            value={partInfo[numberPart]["partName"]}
            onChange={handlePartNameChange}
          />
        </Grid>
      </>
    );
  }



  function PartsDetailsCollectionForm() {
    const fields = [];
    for (let i = 1; i <= partInfo.length; i++) {
      fields.push(singleNewPartCollection(i - 1));
    }

    return <>{fields}</>;
  }

  function submitFormAlert() {
    if (formSubmitMessageOpen[0]) {
      sleep(6000).then(() => {
        setFormSubmitMessageOpen([false, ""]);
      });

      if (formSubmitMessageOpen[1] === "success") {
        return (
          <Fade in={formSubmitMessageOpen[0]}>
            <Container disableGutters={true} sx={alertBox} maxWidth={false}>
              <Alert variant="filled" severity="success">
                <AlertTitle>
                  <strong>Form successfully submitted</strong>
                </AlertTitle>
                <Typography> We have received your message and will respond shortly </Typography>
              </Alert>
            </Container>
          </Fade>
        );
      } else {
        return (
          <Fade in={formSubmitMessageOpen[0]}>
            <Container disableGutters={true} sx={alertBox} maxWidth={false}>
              <Alert variant="filled" severity="error">
                <AlertTitle>
                  <strong>Please fix the following fields:</strong>
                </AlertTitle>
                <Typography> {formSubmitMessageOpen[1]} </Typography>
              </Alert>
            </Container>
          </Fade>
        );
      }
    }
  }

  const handlePermissionCheckboxChange = (event) => {
    setVideoPermissionTrue(event.target.checked);
  };

  //Function to handle the change of the year
  function vehicleYearSelectorList(vehicleYearList) {
    return vehicleYearList.map((vehicleYear) => (
      <MenuItem key={vehicleYear} value={vehicleYear}>
        {vehicleYear}
      </MenuItem>
    ));
  }

  function vehicleMakeSelectorList(vehicleList) {
    let vehicleMakeList = [];
    vehicleList.map((vehicle) => vehicleMakeList.push(vehicle.Make));
    vehicleMakeList = [...new Set(vehicleMakeList)];

    return vehicleMakeList.map((Make) => (
      <MenuItem key={Make} value={Make}>
        {Make}
      </MenuItem>
    ));
  }

  function vehicleMakeSelector(year) {
    //Don't display model selector until make specified
    if (!year)
      return (
        <FormControl sx={{ m: 1, width: "25ch" }}>
          <InputLabel id="select-make">Make*</InputLabel>
          <Select
            labelId="select-make"
            data-testid="select-make"
            id="s-select-make"
            label="make"
            required
            variant="standard"
            disabled
            value={""}
          ></Select>
        </FormControl>
      );
    else {
      return (
        <FormControl sx={{ m: 1, width: "25ch" }}>
          <InputLabel id="select-make">Make*</InputLabel>
          <Select
            labelId="select-make"
            data-testid="select-make"
            id="s-select-make"
            label="make"
            required
            value={make}
            onChange={(make) => setMake(make.target.value)}
          >
            {vehicleMakeSelectorList(CARS[year])}
          </Select>
        </FormControl>
      );
    }
  }

  function vehicleModelSelectorList(vehicleList, Make) {
    let vehicleModelList = [];
    vehicleList.map((vehicle) => {
      if (vehicle.Make == make) {
        vehicleModelList.push(vehicle.Model);
        vehicleModelList = [...new Set(vehicleModelList)];
      }
    });

    return vehicleModelList.map((Model) => (
      <MenuItem key={Model} value={Model}>
        {Model}
      </MenuItem>
    ));
  }

  function vehicleModelSelector(make) {
    //Don't display model selector until make specified
    if (!make)
      return (
        <FormControl sx={{ m: 1, width: "25ch" }}>
          <InputLabel id="select-model">Model*</InputLabel>
          <Select
            labelId="select-model"
            data-testid="select-model"
            id="s-select-model"
            label="model"
            required
            disabled
            variant="standard"
            value={""}
          ></Select>
        </FormControl>
      );
    else {
      return (
        <FormControl sx={{ m: 1, width: "25ch" }}>
          <InputLabel id="select-model">Model*</InputLabel>
          <Select
            labelId="select-model"
            data-testid="select-model"
            id="s-select-model"
            label="model"
            required
            value={model}
            onChange={(model) => setModel(model.target.value)}
          >
            {vehicleModelSelectorList(CARS[year])}
          </Select>
        </FormControl>
      );
    }
  }

  function vehicleTrimSelectorList(vehicleList, Make, Model) {
    let vehicleTrimList = [];
    vehicleList.map((vehicle) => {
      if (vehicle.Make == make && vehicle.Model == model) {
        vehicleTrimList.push(vehicle.Trim);
        vehicleTrimList = [...new Set(vehicleTrimList)];
      }
    });

    return vehicleTrimList.map((Trim) => (
      <MenuItem key={Trim} value={Trim}>
        {Trim}
      </MenuItem>
    ));
  }

  function vehicleTrimSelector(Model) {
    //Don't display model selector until make specified
    if (!Model)
      return (
        <FormControl sx={{ m: 1, width: "25ch" }}>
          <InputLabel id="select-trim">Trim*</InputLabel>
          <Select
            labelId="select-trim"
            data-testid="select-trim"
            id="s-select-trim"
            label="trim"
            variant="standard"
            required
            disabled
            value={""}
          ></Select>
        </FormControl>
      );
    else {
      return (
        <FormControl sx={{ m: 1, width: "25ch" }}>
          <InputLabel id="select-trim">Trim*</InputLabel>
          <Select
            labelId="select-trim"
            data-testid="select-trim"
            id="s-select-trim"
            label="trim"
            required
            value={trim}
            onChange={(trim) => setTrim(trim.target.value)}
          >
            {vehicleTrimSelectorList(CARS[year])}
          </Select>
        </FormControl>
      );
    }
  }

  function vehicleDriveTrainSelector(trim) {
    //Don't display drive train selector until make specified
    if (!trim)
      return (
        <FormControl sx={{ m: 1, width: "25ch" }}>
          <InputLabel id="select-drivetrain">Drive Train</InputLabel>
          <Select
            labelId="select-drivetrain"
            data-testid="select-drivetrain"
            id="s-select-drivetrain"
            label="drivetrain"
            variant="standard"
            required
            disabled
          ></Select>
        </FormControl>
      );
    else {
      return (
        <FormControl sx={{ m: 1, width: "25ch" }}>
          <InputLabel id="select-drivetrain">Drive Train</InputLabel>
          <Select
            labelId="select-drivetrain"
            data-testid="select-drivetrain"
            id="s-select-drivetrain"
            label="drivetrain"
            value={driveTrain}
            onChange={(driveTrain) => setDriveTrain(driveTrain.target.value)}
          >
            <MenuItem value={"AWD"}>AWD</MenuItem>
            <MenuItem value={"FWD"}>FWD</MenuItem>
            <MenuItem value={"RWD"}>RWD</MenuItem>
            <MenuItem value={"4WD"}>4WD</MenuItem>
          </Select>
        </FormControl>
      );
    }
  }

  function vehicleExhaustTypeSelector(trim) {
    //Don't display drive train selector until make specified
    if (!trim)
      return (
        <FormControl sx={{ m: 1, width: "25ch" }}>
          <InputLabel id="select-exhausttype">Exhaust Type*</InputLabel>
          <Select
            labelId="select-exhausttype"
            data-testid="select-exhausttype"
            id="s-select-exhausttype"
            label="exhausttype"
            variant="standard"
            required
            disabled
          ></Select>
        </FormControl>
      );
    else {
      return (
        <FormControl sx={{ m: 1, width: "25ch" }}>
          <InputLabel id="select-exhausttype">Exhaust Type*</InputLabel>
          <Select
            labelId="select-exhausttype"
            data-testid="select-exhausttype"
            id="s-select-exhausttype"
            label="exhausttype"
            required
            value={exhaustType}
            onChange={(exhaustType) => setExhaustType(exhaustType.target.value)}
          >
            <MenuItem value={"Cat-Back"}>Cat-Back</MenuItem>
            <MenuItem value={"Full Exhaust"}>Full Exhaust</MenuItem>
            <MenuItem value={"Axel-Back"}>Axel-Back</MenuItem>
            <MenuItem value={"Other"}>Other</MenuItem>
          </Select>
        </FormControl>
      );
    }
  }

  const LoadingIcon = () => {
    return (
      <Box align="center" sx={{ width: '100%' }}>
        <CircularProgress color="secondary" />
        <Typography>Waiting for data...</Typography>
      </Box>
    )
  }

  return (
    <div>
      {submitFormAlert()}
      <GetAllParts retrievePartsNamesList={retrievePartsNamesList} />
      <form>
        <Container align="center">
          <Grid container maxWidth="sm" align="center">
            <Grid item xs={12} sm={6}>
              <FormControl sx={{ m: 1, width: "25ch" }}>
                <InputLabel id="select-year">Year*</InputLabel>
                <Select
                  labelId="select-year"
                  data-testid="select-year"
                  id="s-select-year"
                  label="year"
                  required
                  value={year}
                  onChange={(year) => setYear(year.target.value)}
                >
                  {vehicleYearSelectorList(Object.keys(CARS))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              {vehicleMakeSelector(year)}
            </Grid>

            <Grid item xs={12} sm={6}>
              {vehicleModelSelector(make)}
            </Grid>

            <Grid item xs={12} sm={6}>
              {vehicleTrimSelector(model)}
            </Grid>

            <Grid item xs={12} sm={6}>
              {vehicleDriveTrainSelector(trim)}
            </Grid>

            <Grid item xs={12} sm={6}>
              {vehicleExhaustTypeSelector(trim)}
            </Grid>

            <Grid item xs={12} sm={12} sx={{ mt: 4 }}>
              <TextField
                id="videoName"
                type="videoName"
                placeholder="Enter your video's title"
                label="Video Title"
                variant="outlined"
                fullWidth
                required
                value={videoName}
                onChange={(videoName) => setVideoName(videoName.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={12} sx={{ mt: 4 }}>
              <TextField
                id="videoLink"
                type="videoLink"
                placeholder="Enter your exhaust video's link"
                label="Video Link"
                variant="outlined"
                fullWidth
                required
                value={videoLink}
                onChange={(videoLink) => setVideoLink(videoLink.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
              <TextField
                id="videoDescription"
                type="videoDescription"
                placeholder="Enter your video's description"
                label="Video Description"
                variant="outlined"
                multiline
                rows={2}
                fullWidth
                value={videoDescription}
                onChange={(videoDescription) => setVideoDescription(videoDescription.target.value)}
              />
            </Grid>

            <Grid sx={{ mt: 2 }} item xs={12}>
              <TextField
                id="email"
                label="Email"
                placeholder="Primary Email"
                variant="outlined"
                fullWidth
                required
                value={submitterEmail}
                onChange={(submitterEmail) => setSubmitterEmail(submitterEmail.target.value)}
              />
            </Grid>

            <Box width={"100%"}>
              <Divider variant="fullWidth" sx={{ m: 4, color: "black" }} />
            </Box>

            <Grid sx={{ mb: 2 }} item xs={12}></Grid>
            <Grid sx={{ mb: 2 }} item xs={12}>
              <Typography variant="h2" sx={{ fontSize: "2rem" }}>
                Aftermarket Parts Used In This Video
              </Typography>
            </Grid>

            <Grid sx={{ mb: 2 }} item xs={12}>
              <Typography variant="h3" sx={{ fontSize: "1.5rem" }}>
                Parts Lookup
              </Typography>
            </Grid>

            {(partsCount > 0) ? <ExistingPartsCollectionForm partsNameList={partsNameList} /> : <LoadingIcon />}

            <Grid sx={{ mt: 5, mb: 2 }} item xs={12}>
              <Typography variant="h3" sx={{ fontSize: "1.5rem" }}>
                Add new Parts
              </Typography>
            </Grid>
            {PartsDetailsCollectionForm()}

            <Grid sx={{ mt: 2 }} item xs={12}>
              <Button variant="contained" align="center" color="success" onClick={addAnotherPart}>
                <AddBoxIcon sx={{ mr: 1 }} />
                <Typography> create new part</Typography>
              </Button>

              <Button variant="contained" align="center" color="error" sx={{ ml: 1 }} onClick={removeAPart}>
                <IndeterminateCheckBoxIcon sx={{ mr: 1 }} />
                <Typography> remove new part</Typography>
              </Button>
            </Grid>

            <Box width={"100%"}>
              <Divider variant="fullWidth" sx={{ m: 4, color: "black" }} />
            </Box>

            <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
              <TextField
                id="AdditionalInfo"
                label="Additional Info"
                multiline
                rows={4}
                placeholder="Type your additional info here"
                variant="outlined"
                fullWidth
                value={additionalInfo}
                onChange={(additionalInfo) => setAdditionalInfo(additionalInfo.target.value)}
              />
            </Grid>

            <FormControlLabel
              control={<Checkbox color="info" checked={videoPermissionTrue} onChange={handlePermissionCheckboxChange} />}
              label="I own the rights to the photos and videos submitted & allow Search Exhaust, as well as any affiliated company, to use and repurpose them for all promotional purposes."
              sx={{ m: 2 }}
            />
            <Box width={"100%"} align="center">
              <Button variant="contained" align="center" color="success" onClick={submitCarForm}>
                <Typography>Submit car for Review</Typography>
              </Button>
            </Box>
          </Grid>
        </Container>
      </form>
    </div>
  );
}
